__turbopack_context__.v({
  "actions": "seller-address-confirmation-module__Aj-0pa__actions",
  "address": "seller-address-confirmation-module__Aj-0pa__address",
  "addressLines": "seller-address-confirmation-module__Aj-0pa__addressLines",
  "backdrop": "seller-address-confirmation-module__Aj-0pa__backdrop",
  "close": "seller-address-confirmation-module__Aj-0pa__close",
  "contained": "seller-address-confirmation-module__Aj-0pa__contained",
  "edit": "seller-address-confirmation-module__Aj-0pa__edit",
  "error": "seller-address-confirmation-module__Aj-0pa__error",
  "header": "seller-address-confirmation-module__Aj-0pa__header",
  "popup": "seller-address-confirmation-module__Aj-0pa__popup",
  "primary": "seller-address-confirmation-module__Aj-0pa__primary",
  "secondary": "seller-address-confirmation-module__Aj-0pa__secondary",
  "title": "seller-address-confirmation-module__Aj-0pa__title",
});
